namespace GeniuzPOS.InitialData {
    export interface PsPanelItemButtonForm {
        ItemButtonId: Serenity.IntegerEditor;
        TouchPanelType: Serenity.StringEditor;
        GroupButtonId: Serenity.IntegerEditor;
        ItemButtonLabel: Serenity.StringEditor;
        UrlUpload: Serenity.StringEditor;
        TxtColor: Serenity.LookupEditor;
        BgColor: Serenity.LookupEditor;
        TxtFontSize: Serenity.DecimalEditor;
        LinkCode: LinkCodeCustomLookup;
        LinkCodeFg: Serenity.RadioButtonEditor;
        ItemButtonImage: Serenity.ImageUploadEditor;
    }

    export class PsPanelItemButtonForm extends Serenity.PrefixedContext {
        static formKey = 'InitialData.PsPanelItemButton';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PsPanelItemButtonForm.init)  {
                PsPanelItemButtonForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.StringEditor;
                var w2 = s.LookupEditor;
                var w3 = s.DecimalEditor;
                var w4 = LinkCodeCustomLookup;
                var w5 = s.RadioButtonEditor;
                var w6 = s.ImageUploadEditor;

                Q.initFormType(PsPanelItemButtonForm, [
                    'ItemButtonId', w0,
                    'TouchPanelType', w1,
                    'GroupButtonId', w0,
                    'ItemButtonLabel', w1,
                    'UrlUpload', w1,
                    'TxtColor', w2,
                    'BgColor', w2,
                    'TxtFontSize', w3,
                    'LinkCode', w4,
                    'LinkCodeFg', w5,
                    'ItemButtonImage', w6
                ]);
            }
        }
    }
}
